import { useState, useRef } from 'react';
import { useInterval } from '@/hooks';
import { useQueryClient } from '@tanstack/react-query';


export const useAuthenticationWindow = ({
  onAuthStatusChange,
}) => {
  const [authWindow, setAuthWindow] = useState(null);
  const intervalActiveRef = useRef(false);
  const queryClient = useQueryClient();


  /* Listen for OAuth status invalidation
  useBus('oauth.status.invalidate', () => {
    setAuthCompleted(true);
  });
*/

  // Poll for auth window status - only runs when intervalActiveRef.current is true
  useInterval(() => {

    console.log('Checking auth window status...');
    if (authWindow && authWindow?.closed) {

      setAuthWindow(null);

      intervalActiveRef.current = false; // Stop the interval

      // Invalidate & refetch all queries so every component updates with new auth
      try {
        queryClient.removeQueries(); // remove cached data immediately 
        queryClient.refetchQueries({ type: 'active' }); // refetch active queries
      } catch (err) {
        console.warn('Failed to invalidate/refetch queries after auth change', err);
      }
      onAuthStatusChange?.();
      
    }
    else if (!authWindow) {

    }
  }, intervalActiveRef.current ? 1500 : null);

  const openAuthWindow = (url, title, authorize) => {
    const window = openAuthenticationWindow(url, title, authorize);
    if (window) {
      setAuthWindow(window);
      intervalActiveRef.current = true; // Start the interval
    } else {
      // Popup was likely blocked
      console.warn('Popup blocked - please allow popups for this site');
    }
  };

  return {
    authWindow,
    openAuthWindow,
  };
};


export function openAuthenticationWindow(url, title, auth = true) {

  const authRedirect = encodeURIComponent(`${window.location.origin}/embed/auth-complete?title=${title}`);
  url = url + (url.includes('?') ? '&' : '?') + `returnUrl=${authRedirect}`;

  const popupWidth = 650;
  const popupHeight = 750;

  let win = window.top;

  // Detect if window.top is usable
  try {
    win.outerWidth;
  } catch {
    win = window;
  }

  const left = win.outerWidth / 2 + win.screenX - (popupWidth / 2);
  const top = win.outerHeight / 2 + win.screenY - (popupHeight / 2);
  console.log('Opening auth window at:', url, left, top);
  
  try {
    const w = window.open(url, `${auth ? 'A' : 'Una'}uthorize_${title.replace(/\s+/g, '_')}`, `popup=1, location=1, width=${popupWidth}, height=${popupHeight}, left=${left}, top=${top}`);
    
    // Check if popup was blocked
    if (!w || w.closed || typeof w.closed === 'undefined') {
      console.warn('Popup blocked or failed to open');
      return null;
    }
    
    return w;
  } catch (error) {
    console.error('Failed to open auth window:', error);
    return null;
  }
}
